import styled from 'styled-components';

export const ChangePropertyDeductibleContainer = styled.div.attrs({
  id: 'ChangePropertyDeductibleContainer',
})`
  width: 94%;
`;
export const TwoColumnContainer = styled.div.attrs({})`
  width: 50%;
  @media (max-width: 599px) {
    grid-template-columns: 100%;
  }
  @media (min-width: 600px) and (max-width: 699px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
  @media (min-width: 700px) and (max-width: 1279px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
  @media (min-width: 1280px) {
    grid-template-columns: 46% 8% 46%;
    grid-template-rows: 1fr;
  }
`;
export const ChangePropertyDeductibleField = styled.div.attrs({})`
  min-width: 250px;
  margin-right: 30px;
`;

export const ChangePropertyDeductibleFieldHeader = styled.h4.attrs({
  id: 'changePropertyDeductibleFieldHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  margin-bottom: 8px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const RequiredField = styled.span.attrs({})`
  color: red;
`;
export const ChangePropertyDeductibleTextAreaField = styled.textarea.attrs({
  id: 'ChangePropertyDeductibleTextAreaField',
})`
  height: 100px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 76%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const ChangePropertyDeductibleButtonsContainer = styled.div.attrs({})`
  text-align: right;
  margin-right: 2%;
  margin-top: 10%;
  display: flex;
  @media (max-width: 384px) {
    text-align: center;
  }
`;
export const ChangePropertyDeductibleButton = styled.button.attrs({})`
  margin-left: 10px;
  padding: 10px 20px;
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  &:disabled {
    background-color: gray;
  }
  @media (max-width: 380px) {
    margin-bottom: 16px;
  }
`;
export const ChangePropertyDeductibleDateInput = styled.input.attrs({
  type: 'date',
})`
  height: 33px;
  min-width: 200px;
`;
export const LinkStyleButton = styled.button.attrs({
  id: 'cancelButton',
})`
  background-color: initial;
  color: ${(props) => props.theme.primaryColor};
  box-shadow: none;
  cursor: pointer;
  margin-right: auto;
  margin-left: 0;

  &:hover {
    background-color: initial;
    color: ${(props) => props.theme.primaryHoverColor};
  }

  &:active {
    background-color: initial;
    color: ${(props) => props.theme.primaryActiveColor};
  }
`;
